<template>
  <cus-dialog>
    <template v-slot:title>
      <div class="orderInfo-button">
        <cus-button
          text="訂單資訊"
          color="blue"
          @click="openInnerDialog('orderInfo')"
          style="min-height: 45px"
        ></cus-button>
      </div>
      <p class="dialog-title">瀏覽</p>
    </template>
    <template v-slot:body>
      <div class="table">
        <div class="table-head">
          <p style="text-align: left">品名</p>
          <p>單價</p>
          <p>數量</p>
          <p>總價</p>
          <p style="text-align: left; padding-left: 30px">編輯</p>
        </div>

        <div class="h-100" :style="`display: grid; grid-template-rows: repeat(${pageItem}, ${100 / pageItem}%)`">
          <div
            :class="[
              'table-item',
              item.item_type === 0 ? '' : 'discount-item',
              selectIndex === item.item_id ? 'item-selected' : '',
            ]"
            v-for="(item, index) in renderList"
            :key="index"
            @click="handleClickItem(item, $event)"
          >
            <div>
              <p>{{ item.item_index }}{{ item.item_type === 0 ? '.' : ' ' }}{{ item.item.label }}</p>
              <p>{{ item.show_price }}</p>
              <p>{{ item.quantity }}</p>
              <p>{{ item.subtotal }}</p>
              <p>{{ item.description }}&emsp;{{ item.note ? `註：${item.note}` : '' }}</p>
              <div v-if="selectIndex === item.item_id" class="item-button-wrap">
                <cus-button
                  text="刪除"
                  color="red"
                  :width="50"
                  fontSize="normal"
                  style="padding-left: 0; min-height: auto"
                  :disabled="!item.can_delete"
                  @click="handleDeleteItem(item)"
                ></cus-button>
                <cus-button
                  v-if="item.can_show_detail"
                  text="詳細"
                  color="green"
                  :width="50"
                  fontSize="normal"
                  style="padding-right: 0; min-height: auto"
                  @click="handleEditItem(item)"
                ></cus-button>
              </div>
            </div>
          </div>
        </div>
        <cus-page :totalPage="totalPage" v-model:currentPage="currentPage"></cus-page>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="關閉" color="white" style="padding: 0" @click="close()"></cus-button>
      </div>
    </template>
  </cus-dialog>

  <!-- 品項詳細/訂單資訊 -->
  <component :is="inner_dialogTemplate"></component>

  <!-- 訂單資訊 -->
</template>
<script>
import { ref, computed, watch, inject, defineAsyncComponent, getCurrentInstance } from 'vue';
import { useGetters, useMutations, useActions } from '@/utils/mapStore';
import { useDialogInDialog } from '@/utils/dialog';
export default {
  name: 'view-table',
  components: {
    MenuDetailInDialog: defineAsyncComponent(() => import('@/components/dialog/MenuDetailInDialog.vue')),
    OrderInfoInDialog: defineAsyncComponent(() => import('@/components/dialog/OrderInfoInDialog.vue')),
  },
  setup() {
    const { proxy } = getCurrentInstance();
    //取得provide參數
    const close = inject('close');
    const dialogVisible = inject('dialogVisible');
    //監聽視窗關閉
    const SET_IS_VIEW = useMutations('menuItem', ['SET_IS_VIEW']);
    watch(dialogVisible, () => {
      if (!dialogVisible.value) {
        SET_IS_VIEW(false);
      }
    });
    //取得購物車清單
    const getCart = useGetters('cart', ['getCart']);
    const copyAllCartList = computed(() => JSON.parse(JSON.stringify(getCart.value)));
    //設定參數
    const selectIndex = ref(null);
    const currentPage = ref(1);
    //處理分頁品項
    const pageItem = ref(10);
    const totalPage = computed(() => Math.ceil(copyAllCartList.value.length / pageItem.value));
    const renderList = computed(() =>
      copyAllCartList.value?.slice((currentPage.value - 1) * pageItem.value, currentPage.value * pageItem.value)
    );
    watch(copyAllCartList, (list, prevList) => {
      //新增品項時，頁碼=最後一頁
      if (list.length > prevList.length) currentPage.value = totalPage.value;
      //刪除品項時，縮減頁碼
      if (list.length < prevList.length && currentPage.value > totalPage.value) currentPage.value = totalPage.value;
    });

    //換頁歸零
    watch(currentPage, () => {
      if (selectIndex.value !== null) {
        selectIndex.value = null;
      }
    });
    //點擊品項、若有選取的付款方式，則不可編輯任何購物車清單
    const getPaidList = useGetters('checkout', ['getPaidList']);
    const handleClickItem = (item, e) => {
      // console.log(e.target.textContent);
      if (getPaidList.value.length > 0) return;
      if (!item.can_delete && !item.can_show_detail) return;
      if (e.target.getAttribute('data-name') === 'cus-button') return;
      if (selectIndex.value === item.item_id) {
        selectIndex.value = null;
      } else {
        selectIndex.value = item.item_id;
      }
    };
    //刪除品項
    const { doRemoveItem, doRemoveEvent } = useActions('cart', ['doRemoveItem', 'doRemoveEvent']);
    const handleDeleteItem = (item) => {
      // console.log(item);
      proxy
        .$confirm({
          content: `是否確定要刪除「${item.item.label}」？`,
        })
        .then(async () => {
          if (item.item_type === 13) {
            await doRemoveEvent(item.form_source_code);
          } else {
            await doRemoveItem(item.item_id);
          }
          selectIndex.value = null;
        })
        .catch((e) => e);
    };
    //編輯品項
    const { inner_dialogTemplate, openInnerDialog } = useDialogInDialog();
    const doSetItemDetail = useActions('menuItem', ['doSetItemDetail']);
    const handleEditItem = (item) => {
      const copyOne = JSON.parse(JSON.stringify(item));
      doSetItemDetail(copyOne);
      openInnerDialog('menuDetail');
    };
    return {
      close,
      pageItem,
      totalPage,
      currentPage,
      renderList,
      selectIndex,
      handleClickItem,
      handleDeleteItem,
      handleEditItem,
      inner_dialogTemplate,
      openInnerDialog,
    };
  },
};
</script>
<style lang="scss" scoped>
.dialog-title {
  text-align: center;
  font-size: 2.4rem;
  line-height: 60px;
  color: $color-blue;
}
.orderInfo-button {
  width: 140px;
  position: absolute;
  top: 16px;
  left: 16px;
}

$column_name: 250px; //品名
$column_detail: 75px; //單價、數量
$column_total: 110px; //總價

.table {
  display: grid;
  grid-template-rows: 44px auto 70px;
  border: 2px solid $color-gray-10;
  border-radius: 4px;
  font-size: 1.8rem;
  @mixin table-rows-grid {
    display: grid;
    grid-template-columns: minmax(0, $column_name) repeat(2, $column_detail) $column_total minmax(0, 1fr);
    align-items: center;
    text-align: right;
    height: 100%;
  }
  &-head {
    @include table-rows-grid;
    padding: 0 15px;
    border-bottom: 2px solid $color-gray-10;
    height: 100%;
    background-color: $color-gray-3;
  }
  &-item {
    padding: 0 15px;
    cursor: pointer;
  }
  &-item > div {
    @include table-rows-grid;
    border-bottom: 1px solid $color-gray-10;
  }
  &-item > div > p:first-child {
    width: 100%;
    font-weight: 500;
    color: $color-blue;
    font-size: 2rem;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &-item > div > p:nth-of-type(4) {
    font-weight: 500;
    color: $color-blue;
    font-size: 2rem;
  }
  &-item > div > p:nth-of-type(5) {
    width: 100%;
    color: $color-gray-60;
    text-align: left;
    padding-left: 30px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  //折扣樣式
  .discount-item {
    color: $color-red;
    > div > p:first-child {
      color: $color-red;
    }
    > div > p:nth-of-type(4) {
      color: $color-red;
    }
  }
  //選中樣式
  .item-selected {
    background-color: $color-blue;
    color: #fff !important;
    p {
      color: #fff !important;
    }
  }
  .item-selected > div {
    grid-template-columns: minmax(0, $column_name) repeat(2, $column_detail) $column_total minmax(0, 1fr) 230px;
    border-bottom: transparent;
  }
  .item-button-wrap {
    display: flex;
    padding-left: 10px;
    height: 90%;
  }
}
</style>
